import React from 'react'
import './ClaimGroupWizardProgressBar.css'

const DEFAULT_STEPS = [
  { index: 0, label: 'Company Details' },
  { index: 1, label: 'Team' },
  { index: 2, label: 'Classification & Methodology' },
  { index: 3, label: 'Questionnaire' },
]

export default function ClaimGroupWizardProgressBar({ currentStep, onStepClick, questionnaireStatus, steps, questionnaireStepIndex }) {
  const STEPS = steps || DEFAULT_STEPS
  const questStepIndex = questionnaireStepIndex ?? 3

  const getStepState = (stepIndex) => {
    if (stepIndex < currentStep) return 'complete'
    if (stepIndex === currentStep) return 'active'
    return 'pending'
  }

  const getStepIcon = (stepIndex) => {
    const state = getStepState(stepIndex)
    if (state === 'complete') return <span className="material-icons md-18">check</span>
    if (stepIndex === questStepIndex && questionnaireStatus === 'in_progress') return <span className="material-icons md-18">schedule</span>
    if (stepIndex === questStepIndex && questionnaireStatus === 'complete') return <span className="material-icons md-18">check</span>
    return stepIndex + 1
  }

  return (
    <div className="wizard-progress">
      {STEPS.map((step, i) => {
        const state = getStepState(step.index)
        return (
          <React.Fragment key={step.index}>
            <div className="wizard-progress__step" onClick={() => onStepClick(step.index)}>
              <div
                className={`wizard-progress__circle ${state === 'active' ? 'wizard-progress__circle--active' : ''} ${state === 'complete' ? 'wizard-progress__circle--complete' : ''}`}
              >
                {getStepIcon(step.index)}
              </div>
              <div
                className={`wizard-progress__label ${state === 'active' ? 'wizard-progress__label--active' : ''}`}
              >
                {step.label}
              </div>
            </div>
            {i < STEPS.length - 1 && (
              <div
                className={`wizard-progress__connector ${currentStep > i ? 'wizard-progress__connector--complete' : ''}`}
              />
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}
